var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartStyleRenko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28571 0.857142V3.71428H8V0.857142H6.28571ZM5.71429 0.285713H8.57143V4.28571H5.71429V0.285713ZM3.42857 7.71428H5.14286V4.85714H3.42857V7.71428ZM2.85714 4.28571H5.71429V8.28571H2.85714V4.28571ZM0.571429 11.7143H2.28571V8.85714H0.571429V11.7143ZM0 8.28571H2.85714V12.2857H0V8.28571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartStyleRenko);
export default __webpack_public_path__ + "static/media/chart-style-renko.64f4c1a2dc61631a563199a56e8f0408.svg";
export { ForwardRef as ReactComponent };